/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-25 18:05:22
 * @LastEditors: changfeng
 * @LastEditTime: 2024-03-25 18:34:04
 */
import http from "@/api";

export const fetchAdList = params => {
	return http.get("/ad/list", params);
};



export const fetchAdPreview = params => {
	return http.get("/ad/previews", params);
};